// app/clarity-init.tsx
"use client";
import { useEffect } from "react";
import Clarity from "@microsoft/clarity";

export function ClarityInit() {
  useEffect(() => {
    Clarity.init("sef9utmz2r"); // byt ut mot ditt riktiga ID
  }, []);

  return null;
}
